import { ApiService } from "./api.service";
import { DOMAIN } from "./domain-constant";

export default class CreditInformationReportService extends ApiService {
  namespace = "credit-info";
  icon = "Summary";
  name = "Type";
  favicon = "Money";
  window = 290;
  Width = 720;
  DOMAIN = DOMAIN.CREDIT_INFORMATION_REPORT;
  action = "actionSummary";
  singular = this.terminology.type.singular;
  plural = this.terminology.type.plural;
  vowel = this.terminology.type.vowel;

  constructor() {
    super("invoices");
  }
}
